import { render, staticRenderFns } from "./generic-loading.vue?vue&type=template&id=4575ddf2&scoped=true"
import script from "./generic-loading.vue?vue&type=script&lang=js"
export * from "./generic-loading.vue?vue&type=script&lang=js"
import style0 from "./generic-loading.vue?vue&type=style&index=0&id=4575ddf2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4575ddf2",
  null
  
)

export default component.exports